(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kfv-product-display"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kfv-product-display')) {
  customElements.define('kfv-product-display', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!['konforiva-masaj','konforiva-ayak-torpusu'].includes(document.body.dataset.productTemplate)) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.priceSelectors = 'cart-drawer .price, cart-drawer .cart-item__price-wrapper, cart-drawer .cart-item__discounted-prices, cart-drawer .cart-item__totals, cart-drawer .cart-drawer__totals__row__money, cart-drawer .totals__subtotal-value, cart-drawer .cart__checkout-button, sticky-atc .sticky-atc__label';
      this.observer = new MutationObserver(records => {
        const externalChanges = records.some(record => record.type !== 'attributes' || record.target !== document.documentElement);
        if (externalChanges) this.schedule();
      });
      this.observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      this.resize = new ResizeObserver(() => this.measure());
      window.addEventListener('resize', () => this.schedule(), options);
      document.addEventListener('transitionend', event => {
        if (event.target === this.sticky) this.measure();
      }, options);
      this.refresh();
    }
    schedule() {
      if (this.pending) return;
      this.pending = requestAnimationFrame(() => {
        this.pending = 0;
        this.refresh();
      });
    }
    refresh() {
      const sticky = document.querySelector('sticky-atc');
      if (sticky !== this.sticky) {
        this.resize.disconnect();
        this.sticky = sticky;
        if (sticky) this.resize.observe(sticky);
      }
      this.formatCart();
      this.measure();
    }
    formatCart() {
      const formatter = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const pattern = /(-?\d{1,3}(?:,\d{3})*\.\d{2}|-?\d+\.\d{2})\s*(?:TL|TRY)\b/g;
      document.querySelectorAll(this.priceSelectors).forEach(element => {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (node.parentElement?.closest('script,style,[aria-hidden="true"]')) continue;
          const formatted = node.nodeValue.replace(pattern, (_, amount) => formatter.format(Number(amount.replaceAll(',', ''))) + ' TL');
          if (formatted !== node.nodeValue) node.nodeValue = formatted;
        }
      });
    }
    measure() {
      let height = 0;
      if (this.sticky) {
        const rect = this.sticky.getBoundingClientRect();
        const style = getComputedStyle(this.sticky);
        if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.top < innerHeight && rect.bottom > 0) height = Math.ceil(rect.height);
      }
      if (height !== this.clearance) {
        this.clearance = height;
        document.documentElement.style.setProperty('--kfv-sticky-clearance', height + 'px');
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.pending);
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      document.documentElement.style.removeProperty('--kfv-sticky-clearance');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
